import React, { Component } from 'react';
import loadingGif from './images/loader.gif';
import propTypes from 'prop-types'

const loadingWrapper = {
  width: '100vw',
  height: '100vh',
  backgroundColor: 'white',
  position: 'fixed',
  zIndex: 50,
  textAlign: 'center',
  paddingTop: '50vh',
  marginTop: '0px',
};

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: true,  
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({active: !this.state.active});
    }, this.props.timer);
  }

  render() { 
    return (
      <div>
        { this.state.active ?
          <div style={loadingWrapper} >
            <img src={loadingGif} alt="" />
          </div>
        : null }
      </div>
    );
  }
}

Loading.propTypes = {
  timer: propTypes.number,
};

Loading.defaultProps = {
  timer: Math.floor(Math.random() * 1000) + 300, // random time between two numbers in ms
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.jsx